export enum taskTemplateDateInitials {
  AssigningDate = 'A',
  ContractDate = 'CD',
  ClosingDate = 'CL',
  ListingAgreementExpiryDate = 'LE',
  OtherDate = 'O',
  Today = 'T',
}
